import { Routes, Route } from 'react-router-dom';
import HomePage from 'pages/HomePage';
import LoginPage from 'pages/LoginPage';
import DashboardPage from 'pages/DashboardPage';
import ProductsPage from 'pages/ProductsPage';
import CategoriesPage from 'pages/CategoriesPage';
import UsersPage from 'pages/UsersPage';
import SubmissionsPage from 'pages/SubmissionsPage';
import BlogsPage from 'pages/BlogsPage';
import SettingsPage from 'pages/SettingsPage';
import AnalyticsPage from 'pages/AnalyticsPage';
import BlogEditorPage from 'pages/BlogEditorPage';
import BlogEditorEditPage from 'pages/BlogEditorEditPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/analytics" element={<AnalyticsPage />} />
      <Route path="/products" element={<ProductsPage />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="/submissions" element={<SubmissionsPage />} />
      <Route path="/blogs" element={<BlogsPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/blog-editor" element={<BlogEditorPage />} />
      <Route path="/blog-editor/edit" element={<BlogEditorEditPage />} />
    </Routes>
  );
}
